import { ReactNode, useMemo } from 'react';
import { CustomMessageBar } from '@shared/components';

type Props = {
  left?: ReactNode;
  /** counts for the success message; hide message if count === 0 */
  success?: { count: number; docs: number; nounSingular: string; nounPlural?: string };
};

const SummaryTopBar = ({ left, success }: Props) => {
  const label = useMemo(() => {
    if (!success || success.count <= 0) return null;
    const np = success.nounPlural ?? `${success.nounSingular}s`;
    const n1 = `${success.count} ${success.count === 1 ? success.nounSingular : np}`;
    const n2 = `${success.docs} document${success.docs === 1 ? '' : 's'}`;
    return `${n1} in ${n2}`;
  }, [success]);

  return (
    <div className="py-3 flex items-center justify-between">
      <div>{left}</div>
      {label ? <CustomMessageBar intent="success" title="Successfully inserted" body={label} /> : null}
    </div>
  );
};

export default SummaryTopBar;
